

































































































































import Vue, { PropType } from "vue";
import HttpClientFactory from "../../../../services/HttpClientFactory";
import { ValidationObserver } from "vee-validate";
import { TimeSelect, DatePicker, Select, Option } from "element-ui";
import { snakeCase } from "lodash";
import ApiAddressReceiverRequest from "../../../../types/receivers/api/ApiAddressReceiverRequest";
import HttpClient from "../../../../services/HttpClient";
export default Vue.extend({
  name: "create-receiver-address",
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  props: {
    receiverId: {
      type: String as PropType<string | null>,
    },
  },
  data() {
    return {
      httpClient: {} as HttpClient,
      addressReceiver: {
        addressLine: "",
        city: "",
        province: "",
        postcode: "",
      } as ApiAddressReceiverRequest,
    };
  },
  methods: {
    async validate(): Promise<boolean> {
      const validated = await (
        this.$refs.form as InstanceType<typeof ValidationObserver>
      ).validate();
      if (!validated) {
        return false;
      }
      try {
        this.httpClient = HttpClientFactory.getInstance();
        await this.httpClient.post(
          process.env.VUE_APP_BACKEND_ENDPOINT +
            "/receivers/v1/" +
            this.receiverId +
            "/add-address",
          this.addressReceiver
        );
        this.$emit("on-validated", validated);
        const success: any = {
          text: this.$t("receiver:saved"),
          type: "success",
        };
        this.$notify(success);
        return true;
      } catch (e) {
        const arrayOfErrors: any[] = e.response.data.errors;
        arrayOfErrors.forEach((error: any) => {
          this.showValidationError(
            snakeCase(error.field),
            snakeCase(error.rule)
          );
        });

        return false;
      }
    },
    showValidationError(field: string, rule: string) {
      const error: any = {
        text: this.$t("receiver:validate." + field + "." + rule),
        type: "error",
      };
      this.$notify(error);
    },
  },
});
